@use './notification-vars';
@use './notification-common';

:host {
  @include notification-vars.wb-notification-vars;
  @include notification-common.wb-notification;
  @include notification-common.wb-notification-hidden;
}

.body {
  @include notification-vars.wb-notification-body-vars;
  @include notification-common.wb-notification-body;
}

.icon {
  @include notification-common.wb-notification-icon;
}

.icon,
.wb-badge {
  @include notification-vars.wb-notification-icon-badge-vars;
}

.icon,
.wb-badge,
.content {
  @include notification-common.wb-notification-icon-content;
}

.content {
  @include notification-common.wb-notification-content;
}

::slotted([slot='inline-action']) {
  @include notification-common.wb-notification-inline-action;
}

:host(:not(.has-footer)) .footer {
  display: none;
}

.footer {
  @include notification-vars.wb-notification-footer-vars;
  @include notification-common.wb-notification-footer;
}

:host([variant='success']) {
  @include notification-vars.wb-notification-success-vars;
}

:host([variant='warning']) {
  @include notification-vars.wb-notification-warning-vars;
}

:host([variant='error']) {
  @include notification-vars.wb-notification-error-vars;
}

:host([variant='highlight']) {
  @include notification-vars.wb-notification-highlight-vars;
}

:host([lifetime]) {
  .wb-round-button {
    @include notification-common.wb-notification-duration-dismiss-button;
  }
}

:host(.is-visible) {
  @include notification-common.wb-notification-visible;
}
